import ItemsViewer from './ItemsViewer';

export default ItemsViewer;